import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { DatePipe } from '@angular/common';
declare var app;

@Component({
  selector: 'app-a2-product-freshness',
  templateUrl: './a2-product-freshness.component.html',
  styleUrls: ['./a2-product-freshness.component.scss']
})
export class A2ProductFreshnessComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  submitArray: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  isNoSixMonthProduct: boolean = false;//无超6个月效期的产品
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) { super(); }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    
    // console.log(that.element);
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // let _obj={};
    // _obj["userid"]=that.com.GetAccount.Id;
    // _obj["storeid"]=that.com.GetStorageKey("tbstore")["ID"];
    // body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.base.GridArrayData = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.base.GridArrayData.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        let isselect:boolean=false;
        that.base.GridArrayData.forEach(item=>{
          if(item.isexceed.value){
            isselect=true;
          }
        });
        that.isNoSixMonthProduct = isselect;
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  EventLink(parms: any, index) {
    let that = this;
    parms['orderNumber'].value = !parms['orderNumber'].value;
    // if(parms['isCheck']){

    // if(!that.baseService.gridSearchDate.find((data)=>data.id==parms.id)){
    //   that.baseService.gridSearchDate.push(parms);
    // }
    // }else{
    //   that.baseService.gridSearchDate.splice(index,1)
    // }
    // that.collectionAppeal.SeacherData(that.baseService.gridSearchDate);
    // console.log(that.baseService.gridSearchDate);
    // console.log(parms);
  }
  EventClick() {
    const that = this;
    that.dataArrayList.forEach(item => {

    });
  }

  /**
   * 如门店无超6个月效期产品，请勾选后保存
   * @param e 
   */
  checkEvent(e) {
    const check = e.target.checked;
    this.isNoSixMonthProduct = check;
    this.base.IsCustomer = check;
    if(this.isNoSixMonthProduct){
      this.base
      this.base.GridArrayData.forEach((data)=>{
        data["num"].value = null;
      });
    }
  }
  onInput(item,event){
    setTimeout(()=>{
      if(event.target.value){
        let numvalue:any= this.com.GetNumber(event.target.value);
       if(numvalue){
         item.num.value = numvalue;
         event.target.value = numvalue;
       }else{
         item.num.value = 0;
         event.target.value=null;
       }
     }else{
         item.num.value = 0;
         event.target.value=null;
     }
     if(item.b_id.value){
       if(!item.num.value){
         // this.msg.Alert("盘库数量不能小于零，默认为1");
        item.num.value=0;
        event.target.value=0;
       }
     }
    },400);
  }
}